import { API } from "aws-amplify";
import { toast } from "react-toastify";

export const UPLOAD_OCR_DOCUMENT_REQUEST = "@@ocr/UPLOAD_OCR_DOCUMENT_REQUEST";
export const UPLOAD_OCR_DOCUMENT_SUCCESS = "@@ocr/UPLOAD_OCR_DOCUMENT_SUCCESS";
export const UPLOAD_OCR_DOCUMENT_FAILURE = "@@ocr/UPLOAD_OCR_DOCUMENT_FAILURE";

export function uploadOcrDocument(file) {
  return async (dispatch) => {
    dispatch({
      type: UPLOAD_OCR_DOCUMENT_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/ocr`);

      if (response.upload_url && file) {
        const form = new FormData();
        let url = response.upload_url.url;
        Object.keys(response.upload_url.fields).forEach((it) => {
          form.append(it, response.upload_url.fields[it]);
        });

        form.append("file", file);

        const requestOptions = {
          method: "POST",
          body: form,
        };
        const res = await fetch(url, requestOptions);

        if (!res.ok) {
          const error = "Document upload failed";
          toast.error(error);
          throw new Error(error);
        }

        const ocrBody = {
          body: {
            key: response.key,
          },
        };
        const ocrResponse = await API.post("cmsAPI", "/ocr", ocrBody);

        dispatch({
          type: UPLOAD_OCR_DOCUMENT_SUCCESS,
          payload: ocrResponse,
        });
        return ocrResponse;
      }

      return undefined;
    } catch (error) {
      dispatch({
        type: UPLOAD_OCR_DOCUMENT_FAILURE,
        payload: error,
      });

      return undefined;
    }
  };
}

export const CLEAR_OCR = "@@ocr/CLEAR_OCR";

export function clearOcr() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_OCR,
    });
  };
}

export const UPLOAD_BATTERY_MODULE_PHOTO_REQUEST = "@@ocr/UPLOAD_BATTERY_MODULE_PHOTO_REQUEST";
export const UPLOAD_BATTERY_MODULE_PHOTO_SUCCESS = "@@ocr/UPLOAD_BATTERY_MODULE_PHOTO_SUCCESS";
export const UPLOAD_BATTERY_MODULE_PHOTO_FAILURE = "@@ocr/UPLOAD_BATTERY_MODULE_PHOTO_FAILURE";

export function uploadBatteryModulePhoto(file) {
  return async (dispatch) => {
    dispatch({
      type: UPLOAD_BATTERY_MODULE_PHOTO_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", `/battery_module_photo`);

      if (response.upload_url && file) {
        const form = new FormData();
        let url = response.upload_url.url;
        Object.keys(response.upload_url.fields).forEach((it) => {
          form.append(it, response.upload_url.fields[it]);
        });

        form.append("file", file);

        const requestOptions = {
          method: "POST",
          body: form,
        };
        const res = await fetch(url, requestOptions);

        if (!res.ok) {
          const error = "Document upload failed";
          toast.error(error);
          throw new Error(error);
        }

        const ocrBody = {
          body: {
            key: response.key,
          },
        };
        const ocrResponse = await API.post("cmsAPI", "/battery_module_photo", ocrBody);

        dispatch({
          type: UPLOAD_BATTERY_MODULE_PHOTO_SUCCESS,
          payload: ocrResponse,
        });
        return ocrResponse;
      }

      return undefined;
    } catch (error) {
      dispatch({
        type: UPLOAD_BATTERY_MODULE_PHOTO_FAILURE,
        payload: error,
      });

      return undefined;
    }
  };
}